import React from "react";
import { CollaborationTrend } from "components/pages/Educator/CollaborationTrend/CollaborationTrend";

export const AdminCollaborationTrend = ({ selectedEducator, sharedClassId, onClassChange }) => {
  if (!selectedEducator) return null;
  return (
    <CollaborationTrend
      key={selectedEducator.id}
      educatorId={selectedEducator.id}
      sharedClassId={sharedClassId}
      onClassChange={onClassChange}
    />
  );
};
